import styled, { css } from 'styled-components';
import { Button } from 'antd';
import { KccButtonType } from './KccButton.types';

const primaryCss = css`
  &.ant-btn-primary {
    border: none;
  }

  &&.ant-btn-primary:disabled,
  &&.ant-btn-primary.ant-btn-disabled {
    background: ${(props): string => props.theme.kcc.colors.GRAY_200};
    border: none;
  }
`;

const secondaryCss = css`
  &&:disabled,
  &&.ant-btn-disabled {
    border-color: ${(props): string => props.theme.kcc.colors.GRAY_200};
  }
`;

const tertiaryCss = css`
  color: ${(props): string => props.theme.kcc.colors.TEXT};
  border: ${(props): number => props.theme.kcc.lineWidth.BORDER}px solid
    ${(props): string => props.theme.kcc.colors.GRAY_300};
  background: ${(props): string => props.theme.kcc.colors.WHITE};

  .ant-btn-icon,
  svg {
    height: 20px;
    width: 20px;
    color: ${(props): string => props.theme.kcc.colors.TEXT};
  }

  &&:disabled,
  &&.ant-btn-disabled {
    border-color: ${(props): string => props.theme.kcc.colors.GRAY_200};
  }

  &&:hover,
  &&.ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    border: ${(props): number => props.theme.kcc.lineWidth.BORDER}px solid
      ${(props): string => props.theme.kcc.colors.GRAY_300};
    background: ${(props): string => props.theme.kcc.colors.WHITE};
  }
`;

const dashedCss = css`
  &&.ant-btn-dashed:disabled,
  &&.ant-btn-dashed.ant-btn-disabled {
    border-color: ${(props): string => props.theme.kcc.colors.GRAY_200};
  }
`;

export const StyledKccButton = styled(Button)<{ $kccType?: KccButtonType }>`
  &&:focus-visible {
    outline: 2px solid ${(props): string => props.theme.kcc.colors.BLUE[500]};
    outline-offset: 2px;
    box-shadow: none;
    transition: outline-offset 0.2s ease, outline-color 0.2s ease;
  }

  &.ant-btn-default:disabled {
    background: ${(props): string => props.theme.kcc.colors.WHITE};
  }

  &&:disabled,
  &&.ant-btn-disabled {
    .ant-btn-icon,
    svg,
    span {
      color: ${(props): string => props.theme.kcc.colors.TEXT_DISABLED};
    }
  }

  &.ant-btn-sm {
    height: ${(props): number => props.theme.kcc.control.HEIGHT_SM}px;
    padding-block: 6px;
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &&.ant-btn-sm {
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.BASE}px;
  }

  .ant-btn-icon {
    display: flex;
  }

  ${(props): ReturnType<typeof css> | false => props.$kccType === 'primary' && primaryCss}
  ${(props): ReturnType<typeof css> | false => props.$kccType === 'secondary' && secondaryCss}
  ${(props): ReturnType<typeof css> | false => props.$kccType === 'tertiary' && tertiaryCss}
  ${(props): ReturnType<typeof css> | false => props.$kccType === 'dashed' && dashedCss}
`;
